import { baseFetchToken } from './BaseSaga'
import ColourActions from '../Redux/ColourRedux'
import { getToken } from '../Services/GetToken'
import { call, put } from 'redux-saga/effects'
import AuthActions from '../Redux/AuthRedux'

export function * getColour (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getColour, token, action.data)
      if (!res.ok) {
        yield put(ColourActions.getColourFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(ColourActions.getColourSuccess(DATA_WITH_PAGE))
        } else {
          yield put(ColourActions.getColourFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(ColourActions.getColourFailure())
  }
}

export function * getAllColour (api, action) {
  yield baseFetchToken(
    api.getAllColour,
    action.data,
    getToken,
    ColourActions.getAllColourSuccess,
    ColourActions.getAllColourFailure
  )
}

export function * createColour (api, action) {
  yield baseFetchToken(
    api.createColour,
    action.data,
    getToken,
    ColourActions.createColourSuccess,
    ColourActions.createColourFailure
  )
}

export function * updateColour (api, action) {
  yield baseFetchToken(
    api.updateColour,
    action.data,
    getToken,
    ColourActions.updateColourSuccess,
    ColourActions.updateColourFailure
  )
}

export function * deleteColour (api, action) {
  yield baseFetchToken(
    api.deleteColour,
    action.data,
    getToken,
    ColourActions.deleteColourSuccess,
    ColourActions.deleteColourFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/ColourSagas.js